import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-medium tracking-widest uppercase text-primary-500 bg-primary-50 px-3 py-1 rounded-full">
            吃瓜视频
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            热门瓜料速览
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg overflow-hidden border border-background-200/70 group cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs font-medium bg-primary-500 text-white px-2.5 py-1 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                    <i className="ri-play-fill text-2xl ml-1"></i>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}